import { ArticleExtraData } from "../../../../../../../articlePage/stateInterfaces";
import { DateDisplay } from "../../../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { SiteItemData } from "../../../../../../interfaces";
import { disablePageRefresh, enablePageRefresh } from "../../../../../../siteWidgets/siteWidgetUtils";
import { FlashesMediaItem } from "../../../../../verticalVideoOverlayPlayer/designs/flashesMediaItem/flashesMediaItem";
import { VerticalVideoOverlayPlayer } from "../../../../../verticalVideoOverlayPlayer/verticalVideoOverlayPlayer";
import { getTranslation } from "../../../../autoTickerRowWidget/autoTickerRowTranslations";
import { categoryObj } from "../../../../newYnetTvVerticalDynamic/components/NewYnetTvVerticalDynamicMutamComponenta";
import { NewsFlashSpecialSlotItem } from "./newsFlashSpecialSlotItem";
require("./m_ynet_newsflashSpecialMobileSlotList.less");

interface NewsFlashSpecialMobileSlotListProps {
    isLTR: boolean
    domain: string
    category: categoryObj
    languageCode: string
    tickerArticles: ArticleExtraData[]
    overlayItems: SiteItemData[]
    isFirstInterval: boolean
    roofOngoingEvent: boolean
    shouldDisplayLoader: boolean
    shouldDisplayTicker: boolean
    highlightingDuration: number
    tickerBottomLink?: string
    tickerBottomTitle?: string
    accordionOpenState?: boolean
    openedItemIndex?: string
    openedItems?: string[]
    onToggleItem?: (id: string) => void
    onOverlayOpen?: () => void
    onOverlayClose?: () => void
    commercialItemsNum?: number
    commercialRepetitionsNum?: number
    commercialBannerId?: string
}

interface NewsFlashSpecialMobileSlotListState {
    selectedVideo: number;
    isOverlayOpen: boolean;
}


export class NewsFlashSpecialMobileSlotList extends React.Component<NewsFlashSpecialMobileSlotListProps, NewsFlashSpecialMobileSlotListState> {

    constructor(props) {
        super(props);
        this.state = {
            selectedVideo: -1,
            isOverlayOpen: false,
        }
    }

    private openMediaDisplayView = (videoIndex: number) => {
        const { onOverlayOpen } = this.props;

        this.setState({ isOverlayOpen: true, selectedVideo: videoIndex });
        disablePageRefresh();
        onOverlayOpen && onOverlayOpen();
    }

    private closeMediaDisplayView = () => {
        const { onOverlayClose } = this.props;

        this.setState({ isOverlayOpen: false, selectedVideo: -1 });
        enablePageRefresh();
        onOverlayClose && onOverlayClose();
    }

    public render() {

        const { isOverlayOpen, selectedVideo } = this.state;
        const { tickerArticles, overlayItems, isFirstInterval, languageCode, tickerBottomLink, shouldDisplayLoader, tickerBottomTitle, shouldDisplayTicker, highlightingDuration, isLTR, domain, roofOngoingEvent, category, accordionOpenState, openedItemIndex, openedItems, onToggleItem, commercialItemsNum, commercialRepetitionsNum, commercialBannerId } = this.props;
        const lang = languageCode ? languageCode.slice(0, 2) : "he";
        const overlayTitle = getTranslation(lang, "News Flash");
        const items = overlayItems.map((item) => {
            const minutesSincePublished = Math.floor((new Date().getTime() - new Date(item.dateUpdatedOnSite).getTime()) / (1000 * 60));
            const isRecentItem = minutesSincePublished < (highlightingDuration || 1);
            const date = isRecentItem ? getTranslation(lang, "Now") : <DateDisplay date={item.dateUpdatedOnSite} isMinutesAgo={true} isArticle={true} />;
            return { ...item, date };
        });

        return (
            <div className="news-flash-special-mobile-slot-list-wrapper">
                {shouldDisplayLoader && <video className="newTickerLoader" src={"https://www.ynet.co.il/images/picsrv/dots-gif.webm"} autoPlay loop muted playsInline />}

                <div className="news-flash-special-mobile-slot-list">
                    {(() => {
                        let visibleItems: any[] = [];
                        const itemList = tickerArticles;
                        const itemLength = itemList.length;
                        const bannerIdPrefix = commercialBannerId || "ads.banner.inline";

                        // Add all items first
                        for (let i = 0; i < itemLength; i++) {
                            const article = itemList[i];
                            const previousRoof = i > 0 ? itemList[i - 1].roof : null;
                            const nextRoof = i < itemList.length - 1 ? itemList[i + 1].roof : null;
                            const accordionState = onToggleItem
                                ? (accordionOpenState || article.articleId === openedItemIndex || (openedItems && openedItems.includes(article.articleId)))
                                : accordionOpenState

                            visibleItems.push(
                                <NewsFlashSpecialSlotItem
                                    index={i}
                                    isLTR={isLTR}
                                    article={article}
                                    nextRoof={nextRoof}
                                    key={article.articleId}
                                    previousRoof={previousRoof}
                                    languageCode={languageCode}
                                    onRowItemToggle={onToggleItem}
                                    isFirstInterval={isFirstInterval}
                                    accordionOpenState={accordionState}
                                    roofOngoingEvent={roofOngoingEvent}
                                    tickerBottomLink={tickerBottomLink}
                                    tickerBottomTitle={tickerBottomTitle}
                                    highlightingDuration={highlightingDuration}
                                    openMediaDisplayView={this.openMediaDisplayView}
                                />
                            );
                        }

                        // Insert commercial items if needed
                        if (itemLength > 0 && commercialItemsNum && commercialItemsNum > 0 && commercialRepetitionsNum && commercialRepetitionsNum > 0) {
                            const availableRepetitions = Math.floor(itemLength / commercialItemsNum);
                            const numberOfTaboolaItems = availableRepetitions < commercialRepetitionsNum ? availableRepetitions : commercialRepetitionsNum;

                            for (let i = 0; i < numberOfTaboolaItems; i++) {
                                visibleItems.splice(commercialItemsNum * (i + 1) + i, 0, <div id={`${bannerIdPrefix}.${i + 1}`} />);
                            }
                        }

                        return visibleItems;
                    })()}
                </div>

                <VerticalVideoOverlayPlayer
                    isLTR={isLTR}
                    domain={domain}
                    isMobile={true}
                    videoItems={items}
                    category={category}
                    index={selectedVideo}
                    isTitleVisible={true}
                    showPrerollAds={false}
                    isSubTitleVisible={true}
                    overlayTitle={overlayTitle}
                    languageCode={languageCode}
                    isOverlayOpen={isOverlayOpen}
                    selectedVideoIndex={selectedVideo}
                    onVideoOverlayClose={this.closeMediaDisplayView}
                    ItemComponent={(props) => <FlashesMediaItem {...props} />}
                />
            </div>
        )
    }
}